/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ successful: NonNullable<unknown>, total: NonNullable<unknown> }} Inventory_Products_Partial_UpdateInputs */

const en_inventory_products_partial_update = /** @type {(inputs: Inventory_Products_Partial_UpdateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.successful}/${i?.total} products`)
};

const es_inventory_products_partial_update = /** @type {(inputs: Inventory_Products_Partial_UpdateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se actualizaron ${i?.successful}/${i?.total} productos`)
};

/**
* | output |
* | --- |
* | "Updated {successful}/{total} products" |
*
* @param {Inventory_Products_Partial_UpdateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_products_partial_update = /** @type {((inputs: Inventory_Products_Partial_UpdateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Products_Partial_UpdateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_products_partial_update(inputs)
	return es_inventory_products_partial_update(inputs)
});